import axios from '@/assets/js/axios.js'
import { APP_CATEGORY_API } from './apis'

// 获取当前app栏目没有选中的品类列表，当atId为null，则选中全部
export function listAppUnmarkedCategory (params) {
  return axios({
    url: APP_CATEGORY_API.LIST_APP_UNMARKED_CATEGORY,
    method: 'post',
    data: params
  })
}

// 批量新增app栏目
export function batchAddAppColumn (params) {
  return axios({
    url: APP_CATEGORY_API.BATCH_ADD_APP_COLUMN,
    method: 'post',
    data: params
  })
}

// APP栏目列表
export function listAppColumn (params) {
  return axios({
    url: APP_CATEGORY_API.LIST_APP_COLUMN,
    method: 'post',
    data: params
  })
}

// APP栏目详情
export function getAppColumnDetail (params) {
  return axios({
    url: APP_CATEGORY_API.GET_APP_COLUMN_DETAIL,
    method: 'post',
    data: params
  })
}

// App栏目移除类品
export function removeCategory (params) {
  return axios({
    url: APP_CATEGORY_API.REMOVE_CATEGORY,
    method: 'post',
    data: params
  })
}

// App栏目添加类品
export function addCategory (params) {
  return axios({
    url: APP_CATEGORY_API.ADD_CATEGORY,
    method: 'post',
    data: params
  })
}

// 发布或下架app栏目
export function publishOrQuashAppColumn (params) {
  return axios({
    url: APP_CATEGORY_API.PUBLISH_OR_QUASH_APP_COLUMN,
    method: 'post',
    data: params
  })
}

// APP栏目修改序号
export function modifyAppColumnNumber (params) {
  return axios({
    url: APP_CATEGORY_API.MODIFY_APP_COLUMN_NUMBER,
    method: 'post',
    data: params
  })
}

// 删除APP栏目
export function delAppColumn (params) {
  return axios({
    url: APP_CATEGORY_API.DEL_APP_COLUMN,
    method: 'post',
    data: params
  })
}

// 根据App的ID进行删除父品类列表
export function delAppCategory (params) {
  return axios({
    url: APP_CATEGORY_API.DEL_APP_CATEGORY,
    method: 'post',
    data: params
  })
}

// 编辑APP栏目
export function editAppColumn (params) {
  return axios({
    url: APP_CATEGORY_API.EDIT_APP_COLUMN,
    method: 'post',
    data: params
  })
}
